import SimpleLightbox from 'simple-lightbox';
import 'simple-lightbox/dist/simpleLightbox.min.css';

export function initGalleryLightboxes(root = document) {
    const galleries = root.querySelectorAll('.hf-gallery-slider');

    galleries.forEach((gallery) => {
        if (gallery.dataset.lightboxInitialized === 'true') {
            return;
        }

        const galleryId = gallery.getAttribute('id');

        if (!galleryId) {
            return;
        }

        if (!gallery.querySelector('.hf-gallery-slider__lightbox-link')) {
            return;
        }

        const selector = `#${CSS.escape(galleryId)} .hf-gallery-slider__lightbox-link`;

        const instance = new SimpleLightbox(selector, {
            captions: true,
            captionsData: 'data-title',
            captionSelector: 'self',
            captionDelay: 0,
            closeText: '×',
            navText: ['←', '→'],
            animationSpeed: 200,
            fadeSpeed: 150,
            swipeClose: true,
            scrollZoom: false,
        });

        gallery.dataset.lightboxInitialized = 'true';
        gallery.highfiveLightbox = instance;
    });
}
